<template>
  <div class="card review-form">

    <div class="padding-a-m">
      <h2 class="margin-a-z margin-b-s">{{ $t('review.reviewBook') }}</h2>
      <div class="payment-info" v-if="!isCorporate">
        <div class="row">
          <div class="small-4 columns text-right">
            <span>{{ $t('review.creditCard') }}:&nbsp;</span>
          </div>
          <div class="small-8 columns">
            <span v-bind:class="['cc-icon medium inline ' + selectedCard.className]"></span>
            <span class="margin-l-xs">{{ selectedCard.number }} ({{ selectedCard.exp }})</span>
          </div>
          <div class="clear"></div>
        </div>
      </div>

      <payment-summary-form :flash="flash" :leg1="leg1" :leg2="leg2" :user="user" v-if="rerender.paymentSummaryForm">
      </payment-summary-form>

      <div v-bind:class="['alert-wrap showhide-fadeslide' + (showSubmitError ? '':' hide')]" v-if="showSubmitError">
        <div class="small-12 columns">
          <div class="alert error margin-b-s margin-t-s">
            {{ submitError }}
          </div>
        </div>
      </div>

      <div class="terms-box">
        {{ $t('review.clickPay') }}
        <a v-bind:href="termsOfUseLink" target="_blank">{{ $t('review.tos') }}</a>.
      </div>

      <div class="row margin-t-s clear">
        <div class="small-12 columns">
          <a class="op-btn btn-xlg btn-block btn-success" @click="checkTimezone">
            <icon name="lock"></icon>
            <span class="font-bold" v-if="currency.code === 'USD'">{{ $t('review.pay') }} {{ applyCurrency(addZero(total)) }}</span>
            <span class="font-bold" v-else>{{ $t('review.pay') }} {{ totalIntl }}</span>
          </a>
        </div>
      </div>
    </div>

    <div class="review-form-footer">
      <icon name="envelope-o"></icon>
      <span>{{ $t('review.sendEmail') }}</span>
      <strong>{{ userEmail }}</strong>
    </div>

    <div :class="['fixed submitting-modal', {display: showSubmittingModal, hide: !submitting}]">
      <div class="table-center">
        <div class="cell-center">
          <div class="submitting">
            <div class="sk-folding-cube">
              <div class="sk-cube1 sk-cube"></div>
              <div class="sk-cube2 sk-cube"></div>
              <div class="sk-cube4 sk-cube"></div>
              <div class="sk-cube3 sk-cube"></div>
            </div>
            <h2 class="margin-a-z">{{ $t('review.submittingRsvp') }}..</h2>
            <p>{{ $t('review.currentlySubmitting') }}</p>
            <p>{{ $t('review.dontRefresh') }}<br/>{{ $t('review.shouldntTake') }}</p>
          </div>
        </div>
      </div>
    </div>

    <div :class="['fixed submitted-modal', {display: showSubmittingModal, show: !submitting}]">
      <div class="table-center">
        <div class="cell-center">
          <div class="submitted">
            <div class="checkmark-circle">
              <div class="background"></div>
              <div v-bind:class="['checkmark draw' + (submitting? '': ' start')]"></div>
            </div>
            <h2 class="margin-a-z">{{ $t('review.successBooked') }}</h2>
            <p>{{ $t('review.tyRsvp') }} </p>
            <p>{{ reservationText }}: <strong>{{ reservationNumber }}</strong></p>
            <p>{{ $t('review.weSentEmail') }} <strong><i>{{userEmail}}</i></strong>.</p>
            <p>
              {{ $t('review.safelyClose') }}
              <a @click="widgetReturn">{{ $t('review.thisLink') }}</a>.
            </p>
            <transition name="slide-down">
              <div class="payment-error" v-show="roundTripPaymentError">
                <i class="fas fa-exclamation-triangle fa-lg"></i>
                <span>
                  {{ $t('review.unfortunately') }}
                </span>
              </div>
            </transition>

            <div class="signup-box" v-if="!userSubscribe">
              <div v-if="subscribeSuccess" class="success">
                <p>{{ $t('review.subscribed') }}</p>
              </div>
              <div v-else>
                <p>{{ $t('review.subscribeMailing') }}</p>
                <a :class="{'op-btn btn-md btn-success':true, 'disabled':subscribeLoading}" @click="subscribe">
                  <span v-if="subscribeLoading">
                    {{ $t('common.loading') }} <i class="fas fa-spinner fa-spin"></i>
                  </span>
                  <span v-else>{{ $t('review.subscribeNow') }}</span>
                </a>
                <p v-if="!!subscribeError" class="error">{{subscribeError}}</p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- <asap ref="asap" :leg1="leg1"></asap> -->
    <!-- <asap :asapData="leg1"></asap> -->
    <lyft-modal></lyft-modal>
  </div>
</template>

<script>
/* global CONFIG */
// import Asap from './AsapSubmit'
// import AsapModal from './AsapModal'
const request = require('browser-request')
import moment from 'moment-timezone'
import PaymentSummaryForm from '../Payment/PaymentSummaryForm.vue'
import xcurrency from '@/modules/api/currency'
import LyftModal from './AsapLyftModal'

export default {
  name: 'review',
  components: {
    'payment-summary-form': PaymentSummaryForm,
    // 'asap': AsapModal
    'lyft-modal': LyftModal
  },
  props: [ 'user', 'flash', 'leg1', 'leg2' ],
  data () {
    return {
      submitting: true,
      showSubmittingModal: false,
      submitError: '',
      showSubmitError: false,
      reservationText: '',
      reservationNumber: '',
      roundTripPaymentError: false,
      subscribeLoading: false,
      subscribeSuccess: false,
      subscribeError: '',
      rerender: {
        paymentSummaryForm: true
      },
      submitLoading: false,
      tmpPortalFee: {
        leg1: 0,
        leg2: 0
      },
      tmpLyftRsvpId: {
        leg1: '',
        leg2: ''
      }
    }
  },
  computed: {
    selectedCard () { return this.$store.state.selectedCard },
    subtotal () {
      if (this.mtech.enabled) {
        let rsvp = this.$store.state.reservation.leg1
        if (rsvp.selectedService) {
          let service = this.mtech.leg1.services[rsvp.selectedService]
          return service.price.breakdown[0].amount + service.price.addMarkup
        }
        return 0
      }

      let rsvp = this.$store.state.reservation
      let leg1 = rsvp.leg1
      let leg2 = rsvp.leg2
      let result = 0
      let priceType = this.lyft.enabled ? 'prices' : 'roundtrip'
      if (leg1.selectedService) {
        let serviceData = leg1.services[leg1.selectedService]
        let servicePricing = serviceData.prices[leg1.passenger - 1]
        if (rsvp.isRoundtrip) servicePricing = serviceData[priceType][leg1.passenger - 1]
        result = servicePricing.price
        // result = this.discountCode.id ? servicePricing.original : servicePricing.price
      }
      if (rsvp.isRoundtrip && leg2.selectedService) {
        let serviceData = leg2.services[leg2.selectedService]
        let servicePricing = serviceData[priceType][leg2.passenger - 1]
        result += servicePricing.price
        // result += this.discountCode.id ? servicePricing.original : servicePricing.price
      }
      // result += parseFloat((result * 0.13).toFixed(2))
      return result
    },
    total () {
      if (this.mtech.enabled) {
        let total = this.subtotal + this.tip
        let rsvp = this.$store.state.reservation.leg1
        if (rsvp.selectedService) {
          let breakdown = this.mtech.leg1.services[rsvp.selectedService].price.breakdown
          for (let i = 1; i < breakdown.length; i++) {
            total += breakdown[i].amount
          }
        }
        total = total - this.$store.state.credits
        return total >= 0 ? total : 0
      }

      let result = (this.tip + this.subtotal + this.meetAndGreetFee + this.airportFee + this.gasFee + this.travelInsurance) - this.credits
      if (this.showConvenienceFee) result += this.convenienceFee
      if (result < 0) { result = 0 }
      return parseFloat(result)
    },
    bidRequest () { return this.$store.state.bidRequest },
    tip () { return this.$store.state.tip.amount },
    credits () { return this.$store.state.credits },
    backLink () { return this.$store.state.progressSteps[0].link.split('#')[0] },
    meetAndGreetFee () {
      let result = 0
      let rsvp = this.$store.state.reservation
      let leg1 = rsvp.leg1
      let leg2 = rsvp.leg2
      if (leg1.isAirportPickup) {
        result += parseInt(leg1.pickupFee)
      }
      if (rsvp.isRoundtrip && leg2.isAirportPickup) {
        result += parseInt(leg2.pickupFee)
      }
      return result
    },
    airportFee () {
      let result = 0
      if (this.leg1.airportFee) {
        result += parseFloat(this.leg1.airportFee)
      }
      if (this.leg2) {
        if ((Object.keys(this.leg2).length > 0) && this.leg2.airportFee) {
          result += parseFloat(this.leg2.airportFee)
        }
      }
      return result
    },
    gasFee () {
      if (this.mtech.enabled) return 0

      let result = 0
      let rsvp = this.$store.state.reservation
      if (rsvp.leg1.selectedService && rsvp.leg1.services[rsvp.leg1.selectedService].gasFee) {
        result += parseFloat(rsvp.leg1.services[rsvp.leg1.selectedService].gasFee)
      }
      if (rsvp.isRoundtrip && rsvp.leg2.selectedService && rsvp.leg2.services[rsvp.leg2.selectedService].gasFee) {
        result += parseFloat(rsvp.leg2.services[rsvp.leg2.selectedService].gasFee)
      }
      return result
    },
    travelInsurance () {
      if (this.mtech.enabled) return 0

      let rsvp = this.$store.state.reservation
      let total = 0

      if (rsvp.leg1.selectedService) {
        total = parseFloat(rsvp.leg1.services[rsvp.leg1.selectedService].travelInsurance)
      }

      if (rsvp.isRoundtrip && rsvp.leg2.selectedService) {
        total += parseFloat(rsvp.leg2.services[rsvp.leg2.selectedService].travelInsurance)
      }
      return total
    },
    userSubscribe () { return this.$store.state.user.emailSubscribed },
    termsOfUseLink () {
      let link = ''
      for (let brand in CONFIG.Brands) {
        if (CONFIG.Brands[brand].id === this.$store.state.brandId) {
          link = '/' + CONFIG.Brands[brand].termsOfServiceLink
        }
      }
      return link
    },
    isCorporate () { return this.$store.state.user.isCorporate },
    userEmail () { return this.$store.state.user.email },
    isRoundtrip () { return this.$store.state.reservation.isRoundtrip },
    charter () { return this.$store.state.reservation.charter },
    optin () { return this.$store.state.reservation.optin },
    mtech () { return this.$store.state.reservation.mtech },
    _lang () { return this.$i18n.locale },
    discountCode () { return this.$store.state.discountCode },
    discountValue () {
      if (!this.discountCode.id) return 0
      let rsvp = this.$store.state.reservation
      let leg1 = rsvp.leg1
      return leg1.services[leg1.selectedService].prices[leg1.passenger - 1].discount
    },
    _rerender () { return this.$store.state.rerender },
    currency () { return this.$store.state.other.currency },
    tipIntl () { return this.$store.state.tip.intl },
    totalIntl () {
      if (this.mtech.enabled) {
        let total = this.applyCurrency(this.subtotal.toFixed(2), false)
        total += this.tipIntl
        let rsvp = this.$store.state.reservation.leg1
        if (rsvp.selectedService) {
          let breakdown = this.mtech.leg1.services[rsvp.selectedService].price.breakdown
          for (let i = 1; i < breakdown.length; i++) {
            total += this.applyCurrency(breakdown[i].amount, false)
          }
        }
        total = total - this.applyCurrency(this.credits, false)
        total = total >= 0 ? total : 0
        return xcurrency.format({
          code: this.currency.code,
          val: total
        })
      }

      let result = this.applyCurrency(this.subtotal.toFixed(2), false)
      result += this.tipIntl
      result += this.applyCurrency(this.meetAndGreetFee, false)
      result += this.applyCurrency(this.airportFee, false)
      result += this.applyCurrency(this.gasFee, false)
      result += this.applyCurrency(this.travelInsurance, false)
      if (this.showConvenienceFee) result += this.applyCurrency(this.convenienceFee, false)
      result -= parseFloat((this.credits * this.currency.value).toFixed(2))
      if (result < 0) { result = 0 }
      return xcurrency.format({
        code: this.currency.code,
        val: result
      })
    },
    savedTimezone () { return this.$store.state.reservation.timezones },
    showConvenienceFee () { return this.convenienceFee > 0 },
    convenienceFee () {
      if (this.mtech.enabled) return 0
      let rsvp = this.$store.state.reservation
      let leg1 = rsvp.leg1
      let leg2 = rsvp.leg2
      let total = 0
      let priceType = rsvp.isRoundtrip ? 'roundtrip' : 'prices'
      if (leg1.selectedService) {
        let serviceData = leg1.services[leg1.selectedService]
        if (this.lyft.enabled) priceType = 'prices'
        let servicePricing = serviceData[priceType][leg1.passenger - 1]
        let price = servicePricing.price
        if (serviceData.portalFee) {
          if (serviceData.portalFeeType === '%') total = parseFloat((price * (serviceData.portalFee / 100)).toFixed(2))
          else total = parseFloat(serviceData.portalFee)
        }
      }
      if (rsvp.isRoundtrip && leg2.selectedService) {
        let serviceData = leg2.services[leg2.selectedService]
        priceType = !this.lyft.enabledLeg2 ? 'roundtrip' : 'prices'
        let servicePricing = serviceData[priceType][leg2.passenger - 1]
        let price = servicePricing.price
        if (serviceData.portalFee) {
          if (serviceData.portalFeeType === '%') total += parseFloat((price * (serviceData.portalFee / 100)).toFixed(2))
          else total += parseFloat(serviceData.portalFee)
        }
      }
      if (!total) return 0
      return parseFloat(total.toFixed(2))
    },
    lyft () { return this.$store.state.reservation.lyft }
  },
  methods: {
    buildPayload (leg, currentLeg) {
      if (Object.keys(leg).length <= 0) return null
      let flightNumber = ''
      let flightName = ''
      let flightNumberDropoff = ''
      let flightNameDropoff = ''
      let rsvp = this.$store.state.reservation[currentLeg]
      if (rsvp.isAirportPickup) {
        flightNumber = leg.flightNumber
        flightName = leg.flightName
      }
      if (!rsvp.isAirportPickup && rsvp.isAirportDropoff) {
        flightNumberDropoff = leg.flightNumber
        flightNameDropoff = leg.flightName
      }
      let pickupTime = moment.tz(leg.pickupTimestamp, 'X', rsvp.timezone || 'America/Los_Angeles').format('X')
      // if (this.mtech.enabled) {
      //   pickupTime = moment(leg.pickupTimestamp, 'X').tz(rsvp.timezone || 'America/Los_Angeles').format('X')
      // }

      let gasFee = 0
      let selectedService = rsvp.services[rsvp.selectedService]
      if (!this.mtech.enabled) {
        gasFee = selectedService.gasFee
      }

      let priceType = this.isRoundtrip ? 'roundtrip' : 'prices'
      if (this.lyft[currentLeg === 'leg1' ? 'enabled' : 'enabledLeg2']) priceType = 'prices'
      let tmpSelected = selectedService[priceType][rsvp.passenger - 1]
      let amount = tmpSelected.price
      let originalPrice = tmpSelected.original
      let legData = {
        pickup: {
          address1: leg.address1,
          address2: leg.address2,
          city: leg.city,
          state: leg.state,
          zip: leg.zip,
          lat: leg.pickUpLocation.split(',')[0].trim(),
          lng: leg.pickUpLocation.split(',')[1].trim(),
          title: leg.title,
          geofenceId: leg.pickupGeofenceId
        },
        dropoff: {
          address1: leg.dropOffAddress1,
          address2: leg.dropOffAddress2,
          city: leg.dropOffCity,
          state: leg.dropOffState,
          zip: leg.dropOffZip,
          lat: leg.dropOffLocation.split(',')[0].trim(),
          lng: leg.dropOffLocation.split(',')[1].trim(),
          title: leg.dropOffTitle,
          geofenceId: leg.dropoffGeofenceId
        },
        pickupTime: pickupTime,
        passengers: leg.passengers,
        luggage: leg.luggage,
        // amount: leg.amount,
        // originalPrice: leg.originalPrice,
        amount: amount,
        originalPrice: originalPrice,
        airportFee: leg.airportFee,
        gasFee: gasFee,
        flightNumber: flightNumber,
        flightName: flightName,
        dropoffFlightName: flightNameDropoff,
        dropoffFlightNumber: flightNumberDropoff,
        asap: false,
        etaInSec: leg.etaInSec,
        serviceTypeId: leg.serviceID,
        serviceType: leg.serviceType,
        pickupType: rsvp.pickupType,
        pickupFee: rsvp.pickupFee,
        distance: leg.distance,
        notes: this.$store.state.driverNotes[currentLeg],
        portalFee: 0
      }

      if (this.showConvenienceFee) {
        legData.portalFee = 0
        if (selectedService.portalFee) {
          if (selectedService.portalFeeType === '%') legData.portalFee = parseFloat((legData.amount * (selectedService.portalFee / 100)).toFixed(2))
          else legData.portalFee = parseFloat(selectedService.portalFee)
        }
        this.tmpPortalFee[currentLeg] = legData.portalFee
      }

      let extraStops = this.$store.state.reservation.extraStop[currentLeg]
      if (extraStops.length) {
        extraStops.forEach(stop => {
          if (!legData.extraStops) {
            legData.extraStops = []
          }
          legData.extraStops.push({
            address1: stop.location.address1,
            address2: stop.location.address2,
            city: stop.location.city,
            state: stop.location.state,
            zip: stop.location.zip,
            lat: stop.location.lat,
            lng: stop.location.lng,
            title: stop.location.title
          })
        })
      }
      if (!CONFIG.useOldQuatation && !this.mtech.enabled) {
        delete legData.serviceType
        legData.serviceTypeId = rsvp.services[leg.serviceType].id
        legData.travelInsurance = selectedService.travelInsurance
      }
      if (!this.$store.state.isManualTip) {
        legData.tip = this.$store.state.tip[currentLeg]
      }

      if (this.optin[currentLeg].enabled) {
        let pricing = this.isRoundtrip ? 'roundtrip' : 'prices'
        if (this.lyft[currentLeg === 'leg1' ? 'enabled' : 'enabledLeg2']) pricing = 'prices'
        let origPrice = selectedService[pricing][(leg.passengers || 1) - 1].price
        let percent = selectedService.optinPercent / 100
        percent = parseFloat((1 - percent).toFixed(2))
        legData.optinShared = {
          serviceTypeId: rsvp.services[leg.serviceType].id,
          amount: parseFloat((origPrice * percent).toFixed(2))
        }
      }

      if (this.mtech.enabled) {
        legData.serviceTypeId = null
        legData.mtechServiceType = this.mtech[currentLeg].services[rsvp.selectedService].product
        legData.pickupTime = moment.tz(this.mtech[currentLeg].pickupDate, 'MM/DD/YYYY hh:mmA', rsvp.timezone).format('X')
        legData.flightTime = moment.tz(rsvp.flightDate, 'MM/DD/YYYY hh:mmA', rsvp.timezone).format('X')
        legData.flightAirline = rsvp.airlineCode
        legData.flightDomestic = this.$store.state.reservation.suggestedTime[currentLeg].isDomestic
        // if (this.mtech[currentLeg].services[rsvp.selectedService].pickupTimes.length) {
        //   legData.pickupTime = this.mtech[currentLeg].services[rsvp.selectedService].pickupTimes[0].unix
        // }

        legData.mtechPrice = this.mtech[currentLeg].services[rsvp.selectedService].price.amount.toFixed(2)
        let priceBeforeCredits = this.subtotal
        if (rsvp.selectedService) {
          let breakdown = this.mtech.leg1.services[rsvp.selectedService].price.breakdown
          for (let i = 1; i < breakdown.length; i++) {
            priceBeforeCredits += breakdown[i].amount
          }
        }
        legData.amount = priceBeforeCredits.toFixed(2)
        legData.originalPrice = priceBeforeCredits.toFixed(2)
      }

      if (this.lyft[currentLeg === 'leg1' ? 'enabled' : 'enabledLeg2']) {
        legData.lyft = {
          ride_type: rsvp.services[rsvp.selectedService].ride_type,
          cost_token: rsvp.services[rsvp.selectedService].cost_token,
          driver_availability_token: rsvp.services[rsvp.selectedService].driver_availability_token || ''
        }
      }

      if (this.discountCode.id && this.discountCode.amount) {
        let pricing = this.isRoundtrip ? 'roundtrip' : 'prices'
        if (this.lyft[currentLeg === 'leg1' ? 'enabled' : 'enabledLeg2']) pricing = 'prices'
        legData.amount = rsvp.services[rsvp.selectedService][pricing][rsvp.passenger - 1].price
      }

      if (parseFloat(legData.amount) < 0) legData.amount = 0
      if (this.currency.code !== 'USD') {
        let tip = this.$store.state.tip.intl
        if (this.isRoundtrip) tip = parseFloat((tip / 2).toFixed(2))
        // if (this.$store.state.isManualTip) {
        //   tip = this.applyCurrency(this.tip, true)
        // }
        legData.currency = {
          code: this.currency.code,
          exchangeRate: this.currency.value,
          amount: this.applyCurrency(legData.amount, false),
          tipAmount: tip,
          pickupFee: this.applyCurrency(rsvp.pickupFee, false),
          airportFee: this.applyCurrency(leg.airportFee, false),
          gasFee: this.applyCurrency(gasFee, false),
          travelInsurance: legData.travelInsurance ? this.applyCurrency(legData.travelInsurance, false) : 0
        }
        if (this.currency.code === 'JPY') {
          legData.currency.amount = parseFloat(xcurrency.format({code: 'JPY', val: legData.currency.amount}, false).replaceAll(',', ''))
          legData.currency.tipAmount = parseFloat(xcurrency.format({code: 'JPY', val: legData.currency.tipAmount}, false).replaceAll(',', ''))
          legData.currency.pickupFee = parseFloat(xcurrency.format({code: 'JPY', val: legData.currency.pickupFee}, false).replaceAll(',', ''))
          legData.currency.airportFee = parseFloat(xcurrency.format({code: 'JPY', val: legData.currency.airportFee}, false).replaceAll(',', ''))
          legData.currency.gasFee = parseFloat(xcurrency.format({code: 'JPY', val: legData.currency.gasFee}, false).replaceAll(',', ''))
          legData.currency.travelInsurance = parseFloat(xcurrency.format({code: 'JPY', val: legData.currency.travelInsurance}, false).replaceAll(',', ''))
        }
      }

      let pickupData = currentLeg === 'leg1' ? legData.pickup : legData.dropoff
      let tzData = this.savedTimezone.find(x => parseFloat(x.lat) === parseFloat(pickupData.lat) && parseFloat(x.lng) === parseFloat(pickupData.lng))
      if (tzData) {
        legData.pickupTimezone = tzData.timezone
      }

      return legData
    },
    submitRequest () {
      if (this.submitLoading) return
      this.submitLoading = true

      if (/*CONFIG.Env == 'production' &&*/ window.gtag) { // eslint-disable-line
        gtag('event', `Review_Payment`) // eslint-disable-line
      }
      if (this.$store.state.reservation.leg1.isAsap) {
        // this.$store.commit('reservation/setAsapModal', true)
        this.$store.commit('reservation/setLyftData', {show: true})
        this.submitLoading = false
        return
      }

      let brands = Object.keys(CONFIG.Brands)
      let brandId = this.$store.state.brandId
      let index = Object.values(CONFIG.Brands).findIndex(x => x.id === brandId)
      let isHudson = CONFIG.Brands[brands[index]].code === 'pts'
      // let isHudson = true

      this.submitting = true
      this.showSubmittingModal = true
      let guestInfo = this.$store.state.guestInfo
      let guestMobile = guestInfo.countryCode + guestInfo.mobile
      if (guestMobile) { guestMobile = '+' + guestMobile }

      let cardId = this.selectedCard.id
      let storeUser = this.$store.state.user
      if (storeUser.isCorporate && storeUser.isDirectBilling) {
        cardId = null
      }

      let guest = guestInfo.proxy ? {
        firstName: guestInfo.firstName,
        lastName: guestInfo.lastName,
        mobile: guestMobile,
        countryCode: guestInfo.countryCode,
        nationalNumber: guestInfo.mobile
      } : null
      if (this.isCorporate) {
        guest = {
          firstName: guestInfo.firstName,
          lastName: guestInfo.lastName,
          mobile: guestMobile,
          countryCode: guestInfo.countryCode,
          nationalNumber: guestInfo.mobile
        }
      }

      if (this.charter.enabled) {
        let charterParam = {
          brandId: this.$store.state.brandId,
          deviceType: 'ww',
          guest: guest,
          hudson: false,
          legs: [
            this.buildPayload(this.bidRequest.leg1, 'leg1'),
            null
          ],
          payment: {
            cardID: cardId,
            tip: this.tip,
            total: this.total,
            fare: this.$store.state.fare,
            pickupFee: this.meetAndGreetFee,
            promo: this.credits
          },
          wheelChair: this.$store.state.user.ada.wheelChairLift ? 1 : 0,
          serviceDog: this.$store.state.user.ada.serviceDog ? 1 : 0,
          token: this.$store.state.user.token,
          source: 'C',
          isCharter: true
        }
        let startDate = moment(this.charter.startDate, 'MM/DD/YYYY hh:mmA')
        let endDate = moment(this.charter.endDate, 'MM/DD/YYYY hh:mmA')
        charterParam.legs[0].pickupTime = startDate.format('X')
        charterParam.legs[0].etaInSec = endDate.diff(startDate, 'seconds')
        charterParam.legs[0].airportGeofenceId = this.$store.state.reservation.leg1.pickup.geofenceType === 'airport' ? this.charter.airportGeoId : null
        delete charterParam.legs[0].dropoff
        // delete charterParam.legs[0].passengers
        // delete charterParam.legs[0].luggage
        delete charterParam.legs[0].distance
        delete charterParam.legs[0].dropoffFlightName
        delete charterParam.legs[0].dropoffFlightNumber
        delete charterParam.legs[0].travelInsurance
        this.$root.$emit('submitCharterRsvp', charterParam)
        return
      }

      let discountAmount = this.discountCode.amount
      if (this.discountCode.type === '%') {
        let rsvp = this.$store.state.reservation
        let leg1 = rsvp.leg1
        if (leg1.selectedService) {
          let serviceData = leg1.services[leg1.selectedService]
          let servicePricing = serviceData.prices[leg1.passenger - 1]
          discountAmount = servicePricing.discount
        }
      }

      let total = this.total
      if (this.showConvenienceFee) {
        total += this.tmpPortalFee.leg1
        if (this.isRoundtrip) total += this.tmpPortalFee.leg2
      }
      total = total.toFixed(2)

      let build = {
        guest: guest,
        leg1: this.buildPayload(this.bidRequest.leg1, 'leg1'),
        leg2: this.buildPayload(this.bidRequest.leg2, 'leg2'),
        payment: {
          cardID: cardId,
          tip: this.tip,
          total: total,
          fare: this.total.toFixed(2),
          pickupFee: this.meetAndGreetFee,
          promo: this.credits
        },
        wheelChair: this.$store.state.user.ada.wheelChairLift ? 1 : 0,
        serviceDog: this.$store.state.user.ada.serviceDog ? 1 : 0,
        hudson: isHudson,
        isCorporate: this.isCorporate,
        token: this.$store.state.user.token,
        quoteId: this.$store.state.reservation.quoteId,
        isMtech: this.mtech.enabled,
        discountCodeAmount: discountAmount,
        discountCodeId: this.discountCode.id
      }

      if (this.lyft.enabled) {
        build.lyft = true
        // this.processLyftBooking(build, 'leg1')
        // return
      }

      // console.log('emit submitRsvp')
      // this.$root.$emit('submitRsvp', build)
      this.submitRsvp(build)
    },
    submitRsvp (event) {
      let self = this
      let user = this.$store.state.user
      let rsvpData = {
        token: event.isCorporate ? event.token : user.token,
        brandId: this.$store.state.brandId,
        guest: event.guest,
        legs: [ event.leg1, event.leg2 || null ],
        payment: event.payment,
        wheelchair: event.wheelChair,
        serviceDog: event.serviceDog,
        source: 'C',
        deviceType: 'ww',
        hudson: event.hudson,
        d2dPayment: true
      }

      if (event.isMtech) {
        rsvpData.quoteId = event.quoteId
        rsvpData.isMTech = event.isMtech
      }
      if (event.lyft) {
        rsvpData.lyft = true
      }
      if (event.discountCodeId) {
        rsvpData.discountCodeId = event.discountCodeId
        rsvpData.discountCodeAmount = event.discountCodeAmount
      }
      this.$sdk.post(self, '/reservations', rsvpData, response => {
        if (!response.error) {
          self.submitRsvpSuccess(response)
        } else {
          self.submitRsvpFail(response)
        }
      }, '/1.1')
    },
    addZero (val) {
      return parseFloat(val).toFixed(2)
    },
    widgetReturn () { window.location.href = window.location.origin },
    subscribe () {
      let self = this
      let user = self.$store.state.user
      if (self.subscribeLoading) { return }
      self.subscribeLoading = true
      self.subscribeError = ''
      self.$sdk.post(self, '/email/subscription', {
        email: user.email,
        firstName: user.firstName,
        lastName: user.lastName,
        brandId: self.$store.state.brandId
      }, res => {
        self.subscribeLoading = false
        if (res.error) {
          self.subscribeError = res.error.message
          self.subscribeSuccess = false
          return
        }
        self.subscribeSuccess = true
      })
    },
    applyCurrency (x, useSymbol = true) {
      x = parseFloat(x)
      x = x * this.currency.value
      if (!useSymbol) {
        return parseFloat(x.toFixed(2))
      }
      return xcurrency.format({
        code: this.currency.code,
        val: x.toFixed(2)
      }, useSymbol)
      // return removeSymbol ? x.toFixed(2) : `${this.currency.symbol}${x.toFixed(2)}`
    },
    checkTimezone () {
      let coords = []
      let rsvp = this.$store.state.reservation
      let leg1 = rsvp.leg1
      let leg2 = rsvp.leg2
      if (this.savedTimezone.length) {
        if (!this.savedTimezone.find(x => parseFloat(x.lat) === parseFloat(leg1.pickup.lat) && parseFloat(x.lng) === parseFloat(leg1.pickup.lng))) {
          coords.push({
            lat: leg1.pickup.lat,
            lng: leg1.pickup.lng
          })
        }
        if (rsvp.isRoundtrip && !this.savedTimezone.find(x => parseFloat(x.lat) === parseFloat(leg2.pickup.lat) && parseFloat(x.lng) === parseFloat(leg2.pickup.lng))) {
          coords.push({
            lat: leg2.pickup.lat,
            lng: leg2.pickup.lng
          })
        }
      } else {
        coords.push({
          lat: leg1.pickup.lat,
          lng: leg1.pickup.lng
        })
        if (rsvp.isRoundtrip) {
          coords.push({
            lat: leg2.pickup.lat,
            lng: leg2.pickup.lng
          })
        }
      }

      if (!coords.length) {
        this.submitRequest()
        return
      }
      this.getTimezone(coords)
    },
    getTimezone (coords) {
      let self = this
      if (!coords.length) {
        this.submitRequest()
        return
      }
      let url = 'https://revgeocode.search.hereapi.com/v1/revgeocode?at={AT}&lang=en-US&apiKey={API_KEY}&show=tz'
      url = url.replace('{AT}', encodeURIComponent(coords[0].lat + ',' + coords[0].lng))
        .replace('{API_KEY}', CONFIG.hereApi.key)
      request.get({
        url: url,
        json: true
      }, function (err, res, body) {
        if (err) { console.log('timezone err:', err) }
        if (body.items.length) {
          self.$store.commit('reservation/addTimezone', {
            lat: coords[0].lat,
            lng: coords[0].lng,
            timezone: body.items[0].timeZone.name
          })
        }
        coords.shift()
        self.getTimezone(coords)
      })
    },
    processLyftBooking (build, leg) {
      let self = this
      let user = self.$store.state.user

      let rsvpData = {
        token: build.isCorporate ? build.token : user.token,
        brandId: self.$store.state.brandId,
        guest: build.guest,
        legs: [build[leg], null],
        payment: build.payment,
        wheelchair: build.wheelChair,
        serviceDog: build.serviceDog,
        source: 'C',
        deviceType: 'ww',
        hudson: build.hudson,
        d2dPayment: true
      }

      let rsvp = this.$store.state.reservation
      let rsvpLeg = rsvp[leg]
      rsvpData.payment.tip = 0
      rsvpData.payment.total = rsvpLeg.services[rsvpLeg.selectedService].prices[rsvpLeg.passenger - 1].price
      rsvpData.payment.pickupFee = 0
      if (!this.lyft[leg === 'leg1' ? 'enabled' : 'enabledLeg2']) {
        rsvpData.payment.total += this.$store.state.tip.amount +
          this.meetAndGreetFee +
          this.airportFee +
          this.gasFee +
          this.travelInsurance -
          this.$store.state.credits
        rsvpData.payment.pickupFee = this.meetAndGreetFee
      }
      if (rsvpData.payment.total < 0) rsvpData.payment.total = 0
      rsvpData.payment.fare = rsvpData.payment.total

      if (build.lyft) {
        rsvpData.lyft = true
      }

      self.$sdk.post(self, '/reservations', rsvpData, res => {
        console.log('booking submit', leg, res)
        if (res.error) {
          console.log('submit error', res)
          self.submitting = true
          self.showSubmittingModal = false
          self.showSubmitError = true
          self.submitError = res.error.message
          return
        }

        if (res.reservationId) self.tmpLyftRsvpId[leg] = res.reservationId[0]
        // if (leg === 'leg1' && self.isRoundtrip) {
        //   self.processLyftBooking(build, 'leg2')
        //   return
        // }

        let newWidget = document.getElementById('new-widget')
        if (newWidget) {
          newWidget.style.overflow = 'hidden'
        }
        if (!self.isRoundtrip) {
          self.reservationText = self.$t('review.yourRsvp1')
          self.reservationNumber = self.tmpLyftRsvpId.leg1
          self.$store.commit('thankyou/setThankYouData', {
            reservationText: self.reservationText,
            reservationNumber: self.tmpLyftRsvpId.leg1
          })
        } else {
          self.reservationText = self.$t('review.yourRsvp2')
          self.reservationNumber = `${self.tmpLyftRsvpId.leg1}, ${self.tmpLyftRsvpId.leg2}`
          self.$store.commit('thankyou/setThankYouData', {
            reservationText: self.reservationText,
            reservationNumber: self.reservationNumber
          })

          self.$store.commit('thankyou/setThankYouData', {roundTripPaymentError: false})
        }
        self.submitting = false
        self.showSubmitError = false
        self.submitError = ''

        if (window.gtag) { // eslint-disable-line
          gtag('event', 'Book a Ride - complete') // eslint-disable-line
        }
        let tmpLyftResId = [self.tmpLyftRsvpId.leg1]
        if (self.isRoundtrip) tmpLyftResId.push(self.tmpLyftRsvpId.leg2)
        localStorage.setItem('BookSuccess', JSON.stringify({
          rsvpId: tmpLyftResId,
          email: user.email,
          firstName: user.firstName,
          lastName: user.lastName,
          brandId: self.$store.state.brandId,
          isSubscribe: user.emailSubscribed
        }))
        self.$root.$router.push('thankyou')
        window.location.href = '#/booking2/complete'
      }, '/1.1')
    },
    submitRsvpSuccess (response) {
      let self = this
      self.submitLoading = false
      let newWidget = document.getElementById('new-widget')
      if (newWidget) {
        newWidget.style.overflow = 'hidden'
      }

      let newRsvpID = response.reservationId
      if (newRsvpID.indexOf(0) > -1) {
        newRsvpID.splice(newRsvpID.indexOf(0), 1)
      }
      if (newRsvpID.length === 1) {
        self.reservationText = self.$t('review.yourRsvp1')
        self.reservationNumber = response.reservationId[0]
        self.$store.commit('thankyou/setThankYouData', {
          reservationText: self.$t('review.yourRsvp1'),
          reservationNumber: response.reservationId[0]
        })
      } else {
        self.reservationText = self.$t('review.yourRsvp2')
        self.reservationNumber = response.reservationId[0] + ', ' + response.reservationId[1]
        self.$store.commit('thankyou/setThankYouData', {
          reservationText: self.$t('review.yourRsvp2'),
          reservationNumber: response.reservationId[0] + ', ' + response.reservationId[1]
        })

        self.$store.commit('thankyou/setThankYouData', {roundTripPaymentError: false})
        if (!response.successAll) {
          self.reservationText = self.$t('review.yourRsvp1')
          self.reservationNumber = response.reservationId[0]
          self.$store.commit('thankyou/setThankYouData', {
            reservationText: self.$t('review.yourRsvp1'),
            reservationNumber: response.reservationId[0]
          })

          setTimeout(function () {
            self.roundTripPaymentError = true
            self.$store.commit('thankyou/setThankYouData', {roundTripPaymentError: true})
          }, 1300)
        }
      }
      // self.submitting = false
      self.showSubmitError = false
      self.submitError = ''

      // if (self.$ga) {
      //   self.$ga.page({
      //     page: '/complete',
      //     title: 'Completion Message',
      //     screenName: 'completeMessage'
      //   })
      // }
      if (window.gtag) { // eslint-disable-line
        gtag('event', 'Book a Ride - complete') // eslint-disable-line
        // let brandName = 'Door2Door'
        // let brand = Object.values(CONFIG.Brands).find(x => x.id === self.$store.state.brandId)
        // if (brand) brandName = brand.name
        // gtag('event', `${brandName} Purchase`, {value: self.total.toFixed(2)}) // eslint-disable-line
      }
      let user = self.$store.state.user
      localStorage.setItem('BookSuccess', JSON.stringify({
        rsvpId: response.reservationId,
        email: user.email,
        firstName: user.firstName,
        lastName: user.lastName,
        brandId: self.$store.state.brandId,
        isSubscribe: user.emailSubscribed
      }))
      if (CONFIG.mainBrandId.indexOf(self.$store.state.brandId) > -1 && window.location.host !== 'usc.primetimeshuttle.com') {
        window.location = '/thankyou'
        return
      }
      self.$root.$router.push('thankyou')
      window.location.href = '#/booking2/complete'
    },
    submitRsvpFail (response) {
      this.submitLoading = false
      this.submitting = true
      this.showSubmittingModal = false
      this.showSubmitError = true
      this.submitError = response.error.message
    }
  },
  watch: {
    '_rerender.paymentSummaryForm': function (val) {
      if (val) {
        this.$store.commit('rerender/setRerenderData', {paymentSummaryForm: false})
        this.rerender.paymentSummaryForm = false
        this.$nextTick(() => {
          this.rerender.paymentSummaryForm = true
        })
      }
    }
  },
  mounted () {
    let self = this
    if (this.$store.state.selectedCard === null) {
      this.$root.$router.push('payment')
      return
    }
    this.$store.commit('setCurrentIndex', 3)
    this.$store.commit('enablePreviousSteps', 3)
    this.$store.commit('setShowPaymentBreakdown', false)

    if (
      !this.$store.state.reservation.leg1.pickupDate &&
      !this.$store.state.reservation.leg1.isAsap &&
      !this.mtech.enabled && !this.charter.enabled
    ) {
      self.$store.commit('setCurrentIndex', 0)
      self.$store.commit('disablePreviousSteps', 1)
      self.$store.commit('disablePreviousSteps', 2)
      self.$store.commit('disablePreviousSteps', 3)
    }

    this.$store.commit('setFare', this.subtotal)
    this.$store.commit('setBidRequest', {
      leg1: this.leg1,
      leg2: this.leg2 || {}
    })

    this.$root.$on('submitRsvpSuccess', (response) => {
      self.submitRsvpSuccess()
    })
    self.$root.$on('submitRsvpFail', (response) => {
      self.submitRsvpFail(response)
    })

    // if (self.$ga) {
    //   self.$ga.page({
    //     page: '/confirm',
    //     title: 'Confirmation Page',
    //     screenName: 'confirmPage'
    //   })
    // }
    // if (window.gtag) { // eslint-disable-line
    //   gtag('event', 'page_view', { // eslint-disable-line
    //     'page': 'Confirmation page'
    //   })
    // }

    let elmnt = document.getElementById('app')
    elmnt.scrollIntoView({behavior: 'smooth', block: 'start'})

    if (/*CONFIG.Env == 'production' &&*/ window.gtag) { // eslint-disable-line
      let rsvp = this.$store.state.reservation
      let service = rsvp.leg1.services[rsvp.leg1.selectedService]
      if (service.brandedName) {
        gtag('event', `Review_${service.brandedName}`) // eslint-disable-line
      }
      let service2 = rsvp.leg2.services[rsvp.leg2.selectedService]
      if (rsvp.isRoundtrip && service2.brandedName) {
        gtag('event', `Review_LEG2${service2.brandedName}`) // eslint-disable-line
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/scss/CreditCardIcons.scss";
@import "../../assets/scss/Review/ReviewDetails.scss";
@import "../../assets/scss/Review/ThankYou.scss";
h2{ font-size: 1.5em!important; }
a { cursor: pointer; }
.clear{ clear:both; }

.payment-error{
  padding: 10px;
  background: #ef8f1a;
  color: #fff;
  font-style: italic;
  max-width: 750px;
  margin: 0 auto;
  border-radius: 3px;
  -webkit-box-shadow: 2px 2px 2px rgba(0,0,0,.3);
  box-shadow: 2px 2px 2px rgba(0,0,0,.3);

  i{
    margin-right: 10px;
    margin-left: 5px;
  }
}

.signup-box{
  border: 1px solid #2eb150;
  width: 100%;
  max-width: 550px;
  margin: 40px auto 0;
  padding: 20px;
  background: #f1fff4;

  p{
    line-height: 145%;
    font-weight: 600;
    color: #555;
  }
  .op-btn{ padding: 12px 40px; }
  .error{
    margin: 10px 0 0;
    color: #f00;
  }
  .success p { margin: 0; }
}

.submitted-modal{ overflow: auto; }

.terms-box{
  font-size: 14px;
  text-align: center;
  margin-top: 10px;
}

.slide-down-enter-active, .slide-down-leave-active { transition: all .3s ease; }
.slide-down-enter, .slide-down-leave-to {
  transform: translateY(-30px);
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// ReviewDetails.vue?467c1597